import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as dashboardActions from "src/redux/slices/dashboardSlice";
import BarChart from "src/components/ui/chart/BarChart";
import { currencyFormatter } from "src/utils/common";

interface TopProductsCardProps {
  days: number;
  limit?: number;
  enabled?: boolean;
}

const TopProductsCard: React.FC<TopProductsCardProps> = ({
  days,
  limit = 6,
  enabled = true,
}) => {
  const dispatch = useAppDispatch();
  const { tenantTopProducts } = useAppSelector((state) => state.dashboard);

  useEffect(() => {
    if (!enabled) return;
    dispatch(dashboardActions.getTenantTopProductsRequest({ days, limit }));
  }, [dispatch, days, limit, enabled]);

  if (!enabled) return null;

  const data = tenantTopProducts.data?.data || [];

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-gray-700">
          Top Selling Products
        </h2>
        <span className="text-xs text-gray-400">Last {days} days</span>
      </div>
      <BarChart
        data={data}
        dataKey="totalSales"
        xKey="name"
        containerClassName="mt-4 h-52 w-full"
        hideYAxis
        barColor="#86EFAC"
        barRadius={[8, 8, 8, 8]}
        xAxisProps={{
          tick: { fontSize: 11 },
          interval: 0,
          angle: -20,
          textAnchor: "end",
          height: 50,
        }}
        tooltipFormatter={(value?: number) =>
          currencyFormatter(value || 0, "IN", 2)
        }
      />
    </div>
  );
};

export default TopProductsCard;
